export const GET_STATES = 'GET_STATES';
export const CREATE_STATE  = 'CREATE_STATE';
export const GET_STATES_STRUCTURE  = 'GET_STATES_STRUCTURE';
export const STATE_REQUEST  = 'STATE_REQUEST';
export const DELETE_STATE  = 'DELETE_STATE';
export const UPDATE_STATE  = 'UPDATE_STATE';
export const STATE_REQUEST_FAILURE  = 'STATE_REQUEST_FAILURE';